import {Component, OnInit} from '@angular/core';
import {SiteDto} from './objects/site.dto';
import {DataService} from '../../services/data.service';
import {PlannedSiteFilterModel} from './objects/planned-site-filter.model';
import {InstallationWeekFilterEnum} from './objects/installation-week-filter.enum';
import {UserService} from '../../services/user.service';
import {CustomerDtoModel} from '../../models/customer-dto.model';
import {ServiceTechnicianDtoModel} from '../../models/service-technician-dto.model';
import {EditOwnPasswordComponent} from '../../components/edit-own-password/edit-own-password.component';
import {Dialog} from '@angular/cdk/dialog';
import {StatusFilterEnum} from "./objects/status-filter.enum";


@Component({
  selector: 'app-planner-page',
  templateUrl: './planner-page.component.html',
  styleUrls: ['./planner-page.component.scss']
})
export class PlannerPageComponent implements OnInit {
  public sites: SiteDto[] = [];
  public viewMode: 'map' | 'list' = 'map';
  public showMenu = false;
  private initialDefaultsApplied = false;
  public customers: CustomerDtoModel[] = [];
  public serviceTechnicians: ServiceTechnicianDtoModel[] = [];

  public readonly installationWeekFilterOptions: { value: InstallationWeekFilterEnum; label: string }[] = [
    {value: InstallationWeekFilterEnum.ALL, label: 'alle'},
    {value: InstallationWeekFilterEnum.FINISHED, label: 'abgeschlossene'},
    {value: InstallationWeekFilterEnum.OPENED, label: 'offene'},
    {
      value: InstallationWeekFilterEnum.OPENED_THIS_AND_NEXT_WEEK,
      label: 'offene anstehende (vergangene, aktuelle + nächste KW)'
    }
  ];

  public readonly statusOptions: { value: StatusFilterEnum; label: string }[] = [
    {value: StatusFilterEnum.PLANNED, label: 'Ungeplante Installationen'},
    {value: StatusFilterEnum.PLANNED_WITH_DATA, label: 'Geplante Installationen'},
    {value: StatusFilterEnum.COMPLETE, label: 'Abgeschlossene Installationen'},
    {value: StatusFilterEnum.INSTALLED, label: 'Installierte Installationen'},
    {value: StatusFilterEnum.COMMENTED, label: 'Kommentar'},
    {value: StatusFilterEnum.ONGOING, label: 'Montierte Gateways'}

  ];

  public currentFilter: PlannedSiteFilterModel = {
    jucCustomerId: undefined,
    installationPersonEmail: 'null',
    installationWeekFilter: InstallationWeekFilterEnum.ALL,
    searchTerm: '',
    siteStatuses: []
  };

  constructor(
    private dataService: DataService,
    private userService: UserService,
    private dialog: Dialog
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.loadFilterOptions();
    await this.applyInitialDefaults();
    await this.loadData();
  }

  public async loadData(filter?: PlannedSiteFilterModel): Promise<void> {
    if (filter) {
      this.currentFilter = {...this.currentFilter, ...filter};
    }

    const data = await this.dataService.getFilteredPlannedSites(this.currentFilter);
    this.sites = data as SiteDto[];
  }

  public setViewMode(viewMode: 'map' | 'list'): void {
    this.viewMode = viewMode;
  }

  public getCurrentWeekNumber(): number {
    const now = new Date();
    const dayOfYear = Math.floor((now.getTime() - new Date(now.getFullYear(), 0, 1).getTime()) / 86400000) + 1;
    const weekNumber = Math.ceil((dayOfYear + (new Date(now.getFullYear(), 0, 1).getDay() - 1)) / 7);
    return weekNumber === 0 ? 1 : weekNumber;
  }

  private async loadFilterOptions(): Promise<void> {
    this.customers = await this.dataService.getAllCustomers() as CustomerDtoModel[];
    this.serviceTechnicians = await this.dataService.getAllServiceTechnicians() as ServiceTechnicianDtoModel[];
  }

  private async applyInitialDefaults(): Promise<void> {
    if (this.initialDefaultsApplied) {
      return;
    }

    const userEmail = this.userService.user?.email;

    if (userEmail && this.serviceTechnicians.findIndex(st => st.email === userEmail.toLowerCase()) !== -1) {
      this.currentFilter.installationPersonEmail = userEmail;
    }

    this.initialDefaultsApplied = true;
  }

  public openOwnPasswordPopup(): void {
    this.dialog.open(EditOwnPasswordComponent, {});
  }
}
